import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormDataService } from './data/formData.service';
import { AuthService } from './shared/services/auth.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Parametros } from './model/parametros';
import { ApiService } from './shared/services/api.service';
import { environment } from "../environments/environment.prod";
import { finalize, switchMap, tap } from 'rxjs/operators';
import { NavigationService } from './shared/services/navigation.Service';
import { Title } from '@angular/platform-browser';
import { HeadGoogleAnalyticsService } from './shared/services/head-google-analytics.service';
import { ToastrService } from 'ngx-toastr';
import { Rol } from './model/rol';
import { OptionSesion } from './model/optionSesion';
import { ReloadComponent } from './services/reloadComponent.service';

@Component({
  selector: 'homepage-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent implements OnInit {
  title = 'CanalDenuncia.app';
  IsHiddenLanding = false;
  IsFormulario = false;
  basePath = environment.baseUrl;
  assetsUrl = environment.baseAssetsUrl;

  // variable to control the menu status
  collapse: boolean = true;
  @Input() formData;
  IsHidden = true;
  href: string = "";

  parametros: Parametros;
  colorprincipal: string = "";
  colorsecundario: string = "";
  colortxtbtn: string = "";
  colortxttitulo: string = "";
  colortxtfondo: string = "";
  colorbgseccion1: string = "";
  colortxtseccion1: string = "";
  colorbgseccion2: string = "";
  colortxtseccion2: string = "";
  colorbgseccion3: string = "";
  colortxtseccion3: string = "";
  clausulas_correo: string = "";
  gestionar_conflicto: string = "";
  triaje: string = "";
  centros: string = ""; //valor del check Centros
  inputAutocomplete: string = "";
  diasinves: string = "";
  diasdecisor: string = "";
  diascompliance: string = "";
  daysreception: string = "";
  terminos: string = "";
  url: string = "";
  documento: string = "";

  politicaEnabled: string = "";
  urlpolitica: string = "";
  docpolitica: string = "";

  politicaClienteEnabled: string = "";
  urlpoliticacliente: string = "";
  docpoliticacliente: string = "";

  colormenulateral: string = "";
  colortxtcabeceras: string = "";
  colortxtbotones: string = "";
  version: string = "";
  boton1: string = "";
  docboton1: string = "";
  boton2: string = "";
  docboton2: string = "";
  boton3: string = "";
  docboton3: string = "";
  logo: string = "";
  HabSSO: string = "";
  forzarloSSO: string = "";
  forzarSSO: string = "";
  dateYear: number = 0;
  language: string;
  popUp: string = "";
  buttonsDisabled: string = "";
  IdPersonalizableEnabled: string = "";
  googleAnalytics: string = "";
  formEmailSupport: string = "";
  backend_host: string = "";
  showSupportForm: string = "";
  conflictCompliance: string = "";
  documentPreview: string = "";
  roles: Rol[] = [];
  isLoading: boolean = false;
  waitingNavigation: boolean = false;

  constructor(
    private apiService: ApiService,
    private formDataService: FormDataService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private navigationService: NavigationService,
    private titleService: Title,
    private headService: HeadGoogleAnalyticsService,
    private reload: ReloadComponent
  ) {
    translate.addLangs(['en', 'es', 'pt', 'it']);
    translate.setDefaultLang('es'); this.getDateYear();

    // Set title based on selected language
    this.translate.get('texto_6', { value: this.language }).subscribe((text: string) => {
      this.titleService.setTitle(text);
    });
  }

  ngOnInit() {
    this.language = this.auth.getLanguage();
    if (!this.language) {
      this.language = 'es';
    }

    this.translate.setDefaultLang(this.language);
    this.setHtmlLangAttribute(this.language);

    const web = environment.base;
    const location = window.location.href;

    // Get token login from url
    const token = location.split('token=')[1];

    if (token) {
      this.isLoading = true;

      this.apiService.loginWithToken(token).pipe(
        tap(res => localStorage.setItem('access_token2', res.accessToken)),
        switchMap(() => this.apiService.meInfo()),
        tap(user => { this.auth.sendToken(
            user.id_user,
            user.n_user,
            user.ape_user,
            user.mail_user,
            user.foto
          );
          localStorage.setItem('isLoggin', '1');
        }),
        finalize(() => {
          this.reload.sendisLoaddingFalse();
          this.initStuff();
          this.configClientParams(web);
          this.listenForComponentLoadingCompletion();

        })
      ).subscribe();
    } else {
      this.initStuff();
      this.configClientParams(web);
      this.listenForComponentLoadingCompletion();
    }

    // Calls the method to check window width
    this.checkWindowWidth();

    // Google Analytics
    if (localStorage.getItem('googleAnalytics') === "1") {
      try {
        this.headService.initializeAnalytics();
      } catch (error) {
        console.error('Error al cargar Google Analytics:', error);
      }
    }
  }

  // Method for update attribute lang in index.html
  setHtmlLangAttribute(lang: string) {
    document.documentElement.lang = lang;
  }

  listenForComponentLoadingCompletion() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.checkWindowWidth);
  }

  /**
   * Get Year For All Rights Reserved
   */
  getDateYear() {
    const currenDate = new Date();
    this.dateYear = currenDate.getFullYear();
  }

  /**
   * Load roles for the current user and society.
   * @param method - The method to use for loading roles.
   * @param sociedad - The society identifier.
   */
  loadRoles(callback?: () => void) {
    this.apiService.getSessionPropertiesUser().subscribe({
      next: (option: OptionSesion[]) => {
        if (!option[0].id_sociedad) {
          return this.toastr.error(this.translate.instant('texto_242'), this.translate.instant('texto_243'));
        }

        this.auth.setSociedad(option[0].id_sociedad);
        this.apiService.searchRoleByUserSociety('setUser', this.auth.getSociedad(), '1').subscribe({
          next: roles => {
            if (roles.code === 200 && roles.success) {
              this.roles = roles.data;

              if (callback) callback();
            }
          },
          error: () => {
            this.toastr.error(this.translate.instant('texto_915'), this.translate.instant('texto_813'));
          }
        });
      },
      error: () => {
        this.toastr.error(this.translate.instant('texto_242'), this.translate.instant('texto_813'));
      }
    });
  }

  /**
   * Initialize application state and routing based on authentication tokens and URL paths.
   * 1. Checks for authentication tokens in local storage.
   * 2. Parses the current URL to determine the appropriate navigation path.
   * 3. Loads user roles if an authentication token is present and navigates accordingly.
   * @returns
   */
  private initStuff() {
    this.IsHiddenLanding = true;
    // Open the sidebar if the Centros feature is enabled
    this.auth.openSidebar(this.auth.getCentros() === '1');
    // Retrieve form data
    this.formData = this.formDataService.getFormData();

    const token = localStorage.getItem('access_token2');
    const tokenComplaint = localStorage.getItem('access_token_complaint');

    const url = new URL(window.location.href);
    const segments = url.pathname.split('/').filter(s => s);

    const validRoutes = [
      'login',
      'inicio',
      'ver-denuncia',
      'enviar-denuncia',
      'restablecer-contrasenia',
      'restablecer-contrasenia-denuncia'
    ];

    const startIndex = segments.findIndex(seg => validRoutes.includes(seg));

    const appSegments = startIndex !== -1
      ? segments.slice(startIndex)
      : [];

    const path = appSegments[0];
    const subPath = appSegments[1];
    const lastSegment = appSegments[appSegments.length - 1];

    // Login token
    if (token) {
      this.IsHiddenLanding = true;
      this.IsFormulario = true;

      // Load user roles
      this.loadRoles(() => {
        const roleIds = this.roles.map(r => r.id_rol).join(',');

        // Navigate based on user roles
        if (roleIds.includes('5') || roleIds.includes('99') || roleIds.includes('4')) {
          this.router.navigate(['dashboard']);
        } else {
          this.router.navigate(['dashboard/complaint-management/mis-denuncias']);
        }
      });
      return;
    }

    // Complaint token
    if (tokenComplaint && path && subPath) {
      this.IsFormulario = true;
      this.router.navigate([path, subPath]);
      return;
    }

    // Complaint password reset
    if (lastSegment?.includes('restablecer-contrasenia-denuncia')) {
      this.router.navigate(['restablecer-contrasenia-denuncia']);
      return;
    }

    // User password reset
    if (lastSegment?.includes('restablecer-contrasenia')) {
      this.router.navigate(['restablecer-contrasenia']);
      return;
    }

    // Homepage routing
    switch (path) {
      case 'login':
        this.IsHiddenLanding = false;
        break;

      case 'ver-denuncia':
      case 'enviar-denuncia':
        if (subPath === 'consultar-denuncia' || subPath === 'finalizar-denuncia') {
          this.router.navigate([path, subPath]);
        }
        break;

      default:
        this.IsHiddenLanding = false;
        this.router.navigate(['inicio']);
        break;
    }
  }

  private configClientParams(web: string) {
    this.apiService.searchParamCliente(web).subscribe({
      next: (parametros) => {
        if (parametros.code === 200 && parametros.success) {
          this.parametros = parametros.data;
          this.clausulas_correo = this.parametros[0].valor;
          this.colorbgseccion1 = this.parametros[1].valor;
          this.colorbgseccion2 = this.parametros[2].valor;
          this.colorbgseccion3 = this.parametros[3].valor;
          this.colorprincipal = this.parametros[4].valor;
          this.colorsecundario = this.parametros[5].valor;
          this.colortxtbtn = this.parametros[6].valor;
          this.colortxtseccion1 = this.parametros[7].valor;
          this.colortxtseccion2 = this.parametros[8].valor;
          this.colortxtseccion3 = this.parametros[9].valor;
          this.colortxttitulo = this.parametros[10].valor;
          this.gestionar_conflicto = this.parametros[11].valor;
          this.diascompliance = this.parametros[12].valor;
          this.diasdecisor = this.parametros[13].valor;
          this.diasinves = this.parametros[14].valor;
          this.logo = this.parametros[15].valor;
          this.terminos = this.parametros[16].valor;
          this.documento = this.parametros[17].valor;
          this.url = this.parametros[18].valor;
          this.colormenulateral = this.parametros[19].valor;
          this.colortxtcabeceras = this.parametros[20].valor;
          this.colortxtbotones = this.parametros[21].valor;
          this.version = this.parametros[22].valor;
          this.docboton1 = this.parametros[23].valor;
          this.boton1 = this.parametros[24].valor;
          this.docboton2 = this.parametros[25].valor;
          this.boton2 = this.parametros[26].valor;
          this.docboton3 = this.parametros[27].valor;
          this.boton3 = this.parametros[28].valor;
          this.triaje = this.parametros[29].valor;
          this.centros = this.parametros[30].valor;
          this.inputAutocomplete = this.parametros[31].valor;
          this.popUp = this.parametros[32].valor;
          this.politicaEnabled = this.parametros[33].valor;
          this.docpolitica = this.parametros[34].valor;
          this.urlpolitica = this.parametros[35].valor;
          this.colortxtfondo = this.parametros[36].valor;
          this.IdPersonalizableEnabled = this.parametros[37].valor;
          this.politicaClienteEnabled = this.parametros[38].valor;
          this.docpoliticacliente = this.parametros[39].valor;
          this.urlpoliticacliente = this.parametros[40].valor;
          this.googleAnalytics = this.parametros[41].valor;
          this.daysreception = this.parametros[42].valor;
          this.formEmailSupport = this.parametros[43].valor;
          this.backend_host = this.parametros[44].valor;
          this.showSupportForm = this.parametros[45].valor;
          this.conflictCompliance = this.parametros[46].valor;
          this.documentPreview = this.parametros[47].valor;
          this.HabSSO = this.parametros[48].valor;
          this.forzarloSSO = this.parametros[49].valor;
          this.forzarSSO = this.parametros[50].valor;
          // Assign 1 to buttonsDisabled if all buttons are disabled.
          if (this.boton1 == '0' && this.boton2 == '0' && this.boton3 == '0') {
            this.buttonsDisabled = '1';
          }
          //console.log(this.manual);
          //console.log(this.docmanual);


          localStorage.setItem('gestionar_conflicto', this.gestionar_conflicto);
          localStorage.setItem('clausulas_correo', this.clausulas_correo);

          localStorage.setItem('diasinves', this.diasinves);
          localStorage.setItem('diasdecisor', this.diasdecisor);
          localStorage.setItem('diascompliance', this.diascompliance);
          localStorage.setItem('daysreception', this.daysreception);
          localStorage.setItem('formEmailSupport', this.formEmailSupport);

          localStorage.setItem('terminos', this.terminos);
          localStorage.setItem('url', this.url);
          localStorage.setItem('documento', this.documento);

          localStorage.setItem('politicaEnabled', this.politicaEnabled);
          localStorage.setItem('urlpolitica', this.urlpolitica);
          localStorage.setItem('docpolitica', this.docpolitica);

          localStorage.setItem('politicaClienteEnabled', this.politicaClienteEnabled);
          localStorage.setItem('urlpoliticacliente', this.urlpoliticacliente);
          localStorage.setItem('docpoliticacliente', this.docpoliticacliente);

          localStorage.setItem('version', this.version);
          localStorage.setItem('boton1', this.boton1);
          localStorage.setItem('docboton1', this.docboton1);

          localStorage.setItem('boton2', this.boton2);
          localStorage.setItem('docboton2', this.docboton2);

          localStorage.setItem('boton3', this.boton3);
          localStorage.setItem('docboton3', this.docboton3);

          localStorage.setItem('triaje', this.triaje);
          localStorage.setItem('centros', this.centros);
          localStorage.setItem('inputAutocomplete', this.inputAutocomplete);

          localStorage.setItem('HabSSO', this.HabSSO);
          localStorage.setItem('forzarloSSO', this.forzarloSSO);
          localStorage.setItem('forzarSSO', this.forzarSSO);

          localStorage.setItem('popUp', this.popUp);
          localStorage.setItem('idPersonalizable', this.IdPersonalizableEnabled);
          localStorage.setItem('googleAnalytics', this.googleAnalytics);
          localStorage.setItem('supportForm', this.showSupportForm);
          localStorage.setItem('conflictCompliance', this.conflictCompliance);
          localStorage.setItem('documentPreview', this.documentPreview);

          this.setEstilosCliente(this.colorprincipal, this.colorsecundario, this.colortxtbtn, this.colortxttitulo, this.colortxtseccion1, this.colorbgseccion2, this.colortxtseccion2, this.colorbgseccion3, this.colortxtseccion3, this.colorbgseccion1, this.colormenulateral, this.colortxtcabeceras, this.colortxtbotones, this.colortxtfondo);
        }
      }, error: (err) => {
        this.toastr.error(this.translate.instant('texto_899'), this.translate.instant('texto_813'));
      }
    });
  }

  isOn(item) {
    this.IsHidden = false;
    this.IsHiddenLanding = true;
    this.IsFormulario = true;
  }

  hideModal() {
    this.auth.logoutSimple();
    this.IsHidden = true;
    this.IsHiddenLanding = false;
    this.IsFormulario = false;
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/login']);
    });
  }

  setEstilosCliente(color1: string, color2: string, color3: string, color4: string, color5: string, color6: string, color7: string, color8: string, color9: string, color10: string, color11: string, color12: string, color13: string, color14: string) {
    document.documentElement.style.setProperty('--main-color-bg', color1);
    document.documentElement.style.setProperty('--secondary-color-bg', color2);
    document.documentElement.style.setProperty('--color-txt-btn', color3);
    document.documentElement.style.setProperty('--color-txt-titulo', color4);
    document.documentElement.style.setProperty('--color-txt-seccion-1', color5);
    document.documentElement.style.setProperty('--color-bg-seccion2', color6);
    document.documentElement.style.setProperty('--color-txt-seccion2', color7)
    document.documentElement.style.setProperty('--color-bg-seccion3', color8);
    document.documentElement.style.setProperty('--color-txt-seccion3', color9);
    document.documentElement.style.setProperty('--color-bg-seccion1', color10);
    document.documentElement.style.setProperty('--color-txt-menu-lateral', color11);
    document.documentElement.style.setProperty('--color-txt-cabeceras', color12);
    document.documentElement.style.setProperty('--color-txt-botones', color13);
    document.documentElement.style.setProperty('--color-txt-fondo', color14);
  }

  login2() {
    this.apiService.loginSingleSignOn();
  }

  mostrarLogin() {
    this.router.navigate(['/login'])
  }

  logar() {
    //console.log(localStorage.getItem("forzarSSO"));
    if (localStorage.getItem("forzarSSO") == "1") {
      this.login2();
    } else {
      this.mostrarLogin();
    }
  }

  /**
  * Method for navigating between sections of the home page.
  * @param sectionId - The ID of the section to navigate to.
  */
  navigateToSection(sectionId: string) {
    this.navigationService.navigateToSection(sectionId);
  }

  /**
   * Method for navigating to "boton1" or "url" after navigating to section "services".
   */
  navigateToButton() {
    // Navigate to the 'services' section first.
    this.navigationService.navigateToSection('services');
    // Focus button or url
    if (this.buttonsDisabled == "1") {
      this.navigationService.navigateToUrlSupport();

    } else {
      this.navigationService.navigateToButton();
    }
  }


  /**
  * Toggles the collapse state of the menu.
  * If the menu is collapsed, it expands it, and vice versa.
  */
  toggleCollapse(): void {
    this.collapse = !this.collapse;
  }

  /**
  * Listens for window resize events and triggers the method to check window width
  */
  @HostListener('window:resize')
  checkWindowWidth() {
    this.collapse = window.innerWidth > 991;
  }


}
